import { Hero } from "@/components/site/Hero";
import { TrustStrip } from "@/components/site/TrustStrip";
import { ImpactStats } from "@/components/site/ImpactStats";
import { ProjectsGrid } from "@/components/site/ProjectsGrid";
import { SponsorBand } from "@/components/site/SponsorBand";
import { FundraiserBand } from "@/components/site/FundraiserBand";
import { ConnectBand } from "@/components/site/ConnectBand";
import { HowItWorks } from "@/components/site/HowItWorks";
import { ProjectMap } from "@/components/site/ProjectMap";
import { ImpactCalculator } from "@/components/site/ImpactCalculator";
import { NewsStrip } from "@/components/site/NewsStrip";
import { Testimonials } from "@/components/site/Testimonials";
import { CircleBand } from "@/components/site/CircleBand";
import { BirthdayPledgeBand } from "@/components/site/BirthdayPledgeBand";
import { EventBanner } from "@/components/site/EventBanner";
import { Link } from "react-router-dom";
import { Seo } from "@/components/seo/Seo";
import { buildBreadcrumbsJsonLd } from "@/lib/seo";

// Landing page loads all sections eagerly (no lazy/visibility gating) so the
// full experience is available immediately. Sub-pages remain route-level
// lazy-loaded in App.tsx.
const Index = () => {
  return (
    <>
      <Seo
        title="Raise Sri Lanka — Bring hope to every Sri Lankan family"
        description="Donate monthly, give once, sponsor a project, or start a fundraiser. A US 501(c)(3) funding education, health, and disaster recovery across Sri Lanka."
        url="/"
        type="website"
        jsonLd={buildBreadcrumbsJsonLd([{ name: "Home", url: "/" }])}
      />
      <Hero />
      <TrustStrip />
      <ImpactStats />
      <ProjectsGrid />
      <section className="container mx-auto px-4 py-16">
        <div className="mx-auto max-w-3xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">Where we work</span>
          <h2 className="mt-3 font-display text-3xl font-semibold md:text-4xl">Every project, on the map</h2>
          <p className="mt-2 text-muted-foreground">Each pin is a real family or community we've helped.</p>
        </div>
        <div className="mt-8">
          <ProjectMap height={420} />
        </div>
        <div className="mt-4 text-center">
          <Link to="/map" className="text-sm font-medium text-primary underline-offset-4 hover:underline">
            Explore the full map →
          </Link>
        </div>
      </section>
      <SponsorBand />
      <ImpactCalculator />
      <CircleBand />
      <FundraiserBand />
      <EventBanner />
      <BirthdayPledgeBand />
      <HowItWorks />
      <ConnectBand />
      <NewsStrip />
      <Testimonials />
    </>
  );
};

export default Index;
